/**
 * Generated bundle index. Do not edit.
 */

export {YouTubePlayerModule} from './public_api';

export {YoutubePlayerService as ɵb} from './src/app/youtube-player/services/youtube-player.service';
export {YoutubePlayerComponent as ɵa} from './src/app/youtube-player/youtube-player.component';